export enum DataHooks {
  SlotsNotification = 'slots-notification',
  CTA = 'slots-notification-cta',
}
